import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
// Redux
import { Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from '../ViewMessage.css';
// Component
import CurrencyConverter from '../../CurrencyConverter';

// Locale
import messages from '../../../locale/messages';

const CancelDetails = ({ userType, cancelData: { refundToGuest, payoutToHost, currency }, reservationData: { total, hostServiceFee } }) => {

	let earnedAmount = 0, missedEarnings = 0, refund = 0;
	earnedAmount = payoutToHost;
	refund = refundToGuest;
	missedEarnings = (total - hostServiceFee) - earnedAmount

	return (
		<div>

			{((userType === 'host' && (earnedAmount > 0 || missedEarnings > 0)) || (userType === 'guest' && refund > 0)) && <>
				<hr className={s.horizondalLine} />
				<h4 className={cx(s.tripDetailHeading, s.spaceBottom15)}>
					<span><FormattedMessage {...messages.payment} /></span>
				</h4>
				{
					userType === 'host' && earnedAmount > 0 && <Row className={s.paymentDetailText}>
						<Col xs={7} sm={7} className={cx(s.textLeft, 'textRightRTL')}>
							<span><FormattedMessage {...messages.earnedAmount} /></span>
						</Col>
						<Col xs={5} sm={5} className={cx(s.textRight, 'textLeftRTL')}>
							<span className={cx(s.txtBreak)}>
								<CurrencyConverter
									amount={earnedAmount}
									from={currency}
								/>
							</span>
						</Col>
					</Row>
				}
				{
					userType === 'host' && missedEarnings > 0 && <Row className={cx(s.paymentDetailText)}>
						<Col xs={7} sm={7} className={cx(s.textLeft, 'textRightRTL')}>
							<span><FormattedMessage {...messages.missedEarnings} /></span>
						</Col>
						<Col xs={5} sm={5} className={cx(s.textRight, 'textLeftRTL')}>
							<span className={cx(s.txtBreak)}>
								<CurrencyConverter
									amount={missedEarnings}
									from={currency}
								/>
							</span>
						</Col>
					</Row>
				}
				{
					userType === 'guest' && refund > 0 && <Row className={cx(s.paymentDetailText)}>
						<Col xs={7} sm={7} className={cx(s.textLeft, 'textRightRTL')}>
							<span><FormattedMessage {...messages.refundAmount} /></span>
						</Col>
						<Col xs={5} sm={5} className={cx(s.textRight, 'textLeftRTL')}>
							<span className={cx(s.txtBreak)}>
								<CurrencyConverter
									amount={refund}
									from={currency}
								/>
							</span>
						</Col>
					</Row>
				}
			</>}
		</div>
	);
}

CancelDetails.propTypes = {
	userType: PropTypes.string.isRequired,
	formatMessage: PropTypes.any,
	cancelData: PropTypes.shape({
		guestServiceFee: PropTypes.number,
		hostServiceFee: PropTypes.number,
		refundToGuest: PropTypes.number,
		payoutToHost: PropTypes.number,
		total: PropTypes.number,
		currency: PropTypes.string,
	})
};
export default withStyles(s)(CancelDetails);

